import clsx from 'clsx';
import {useSelector} from 'react-redux';

import AemImage from '@/components/AemImage/AemImage';
import {selectIsEmbedded} from '@/state/selectors/app';
import type {ImageModel} from '@/types/content';

type BigCardContentProps = {
    title?: string;
    imageMedia?: ImageModel[];
    isBigBorderless: boolean;
};

const BigCardContent = ({title, imageMedia, isBigBorderless}: BigCardContentProps) => {
    const isEmbedded = useSelector(selectIsEmbedded);
    const hasImage = Boolean(imageMedia?.length);

    return (
        <div
            className={clsx(
                'relative w-full overflow-hidden rounded-2xl',
                isEmbedded && 'h-48 bg-tips-card-surface-secondary'
            )}
        >
            {hasImage && (
                <AemImage
                    imageMedia={imageMedia}
                    className={isEmbedded ? 'absolute inset-0 overflow-hidden' : 'w-full'}
                    pictureClassName={isEmbedded ? 'block h-full w-full' : 'w-full'}
                    imgClassName={clsx(
                        isEmbedded
                            ? 'h-full w-full object-cover object-center'
                            : 'h-auto w-full object-cover',
                        isBigBorderless && (isEmbedded ? 'object-left' : 'object-right')
                    )}
                />
            )}

            <h2 className='pointer-events-none absolute inset-x-0 top-0 m-0 px-4 pt-4 font-bold text-lg text-white'>
                {title}
            </h2>
        </div>
    );
};

export default BigCardContent;
